<template>
    <v-navigation-drawer stateless value="true" class="catalog-navigation catalog-navigation--max">
        <v-toolbar text color="white">
            <v-toolbar-title>
                <v-text-field
                    label="Поиск"
                    solo
                    text
                    single-line
                    class="mb-0"
                    prepend-icon="search"
                    hide-details/>
            </v-toolbar-title>
            <v-spacer/>
            <v-menu bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item @click="addPromo">
                        <v-list-item-title>Добавить</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-list v-if="getPromos.length > 0" class="v-list--booking">
            <v-list-item
                :key="promo.id"
                active-class="active"
                v-if="!promo.deleted"
                v-for="promo in getPromos"
                @click="editPromo(promo.id)"
                :class="`v-list--booking_state f-width ${$route.params.promoCodeId === promo.id ? 'active' : ''}`">
                <v-list-item-title v-text="promo.name"/>
                <v-list-item-action v-if="promo.all_count === 0">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon text color="success" v-on="on">
                                <v-icon>check</v-icon>
                            </v-btn>
                        </template>

                        <span>Использован на 100%</span>
                    </v-tooltip>
                </v-list-item-action>
                <v-list-item-action>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon @click.prevent="promoChangeStatus(promo.id, promo.status)" v-on="on">
                                <template v-if="promo.status">
                                    <v-icon>remove_red_eye</v-icon>
                                </template>
                                <template v-else>
                                    <v-icon>visibility_off</v-icon>
                                </template>
                            </v-btn>
                        </template>
                        <span>{{ promo.status ? 'Активен' : 'Не активен' }}</span>
                    </v-tooltip>
                </v-list-item-action>
                <v-list-item-action>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon @click.prevent="deletePromo(promo.id)" v-on="on">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </template>
                        <span>Удалить</span>
                    </v-tooltip>
                </v-list-item-action>
            </v-list-item>
        </v-list>
        <empty v-else/>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Promo from '../../../../api/promo'
    import Empty from '../../../../components/Loader/Empty'

    export default {
        name: 'promoNavigation',
        components: { Empty },
        methods: {
            addPromo () {
                this.$router.push({ name: 'addPromoCode' })
            },
            editPromo (id) {
                this.$router.push({
                    name: 'viewPromoCode',
                    params: { promoCodeId: id }
                })
            },
            deletePromo (id) {
                Promo
                    .delete(id)
                    .then(response => {
                        this.$store.commit('deletePromo', response.data.data)
                        this.$store.commit('showSnackbar', {
                            text: 'Промокод удален',
                            color: 'info'
                        })
                    })
                    .catch(error => new Error(error))
            },
            promoChangeStatus (id, status) {
                Promo
                    .changeStatus({
                        id,
                        status: !status
                    })
                    .then(response => {
                        this.$store.commit('changePromoStatus', response.data.data)
                        this.$store.commit('showSnackbar', {
                            text: 'Статус промокода изменен',
                            color: 'success'
                        })
                    })
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
            }
        },
        computed: mapGetters([
            'getPromos'
        ])
    }
</script>
